/*
  <ax-quantity-breaks> - selecteur de paliers de quantite.

  Palier a 1 unite : pilote seulement input[name="quantity"] ; le formulaire du theme
  ajoute la variante choisie dans le selecteur habituel.

  Palier a plusieurs unites sur un produit a variantes : chaque piece a son propre
  selecteur (ex. parfum). product-form.js ne sait ajouter qu'UNE variante : on intercepte
  donc la soumission (en phase de capture, avant son ecouteur) et on ajoute nous-memes
  les pieces, regroupees par variante, via /cart/add.js, puis on rend le tiroir panier
  comme le fait product-form.js.

  Ne modifie aucun prix : la remise vient des remises automatiques Shopify « Pack »
  (5 % des 2, 10 % des 3).
*/
(function () {
  if (customElements.get('ax-quantity-breaks')) return;

  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    function withSeparators(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts.join(decimal) : parts[0];
    }
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return withSeparators(value, 2, ',', '.');
        case 'amount_no_decimals': return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSeparators(value, 0, '.', ',');
        case 'amount_with_space_separator': return withSeparators(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withSeparators(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withSeparators(value, 2, "'", '.');
        default: return withSeparators(value, 2, ',', '.');
      }
    });
  }

  var ADD_ERROR = 'Impossible d’ajouter ces pièces au panier.';

  class AxQuantityBreaks extends HTMLElement {
    connectedCallback() {
      var dataNode = this.querySelector('[data-ax-qb-data]');
      if (!dataNode) return;

      try {
        this.data = JSON.parse(dataNode.textContent);
      } catch (e) {
        return;
      }

      this.moneyFormat = this.dataset.moneyFormat || '{{amount}} dh';
      this.freeShipThreshold = parseInt(this.dataset.freeShippingThreshold || '0', 10);
      this.freeShipLabel = this.dataset.freeShippingLabel || '';
      this.perUnitSuffix = this.dataset.perUnitSuffix || '';
      this.updateAtc = this.dataset.updateAtc === 'true';
      this.summaryTotalLabel = this.dataset.summaryTotalLabel || '';
      this.summarySaveLabel = this.dataset.summarySaveLabel || '';

      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-ax-qb-tier]'));
      if (!this.tiers.length) return;

      this.summary = this.querySelector('[data-ax-qb-summary]');
      this.errorNode = this.querySelector('[data-ax-qb-error]');
      /* Toute la section produit : formulaire principal, barre collante, selecteur. */
      this.scope = document.getElementById('shopify-section-' + this.dataset.sectionId) ||
        this.closest('.product') || document;
      this.form = document.getElementById(this.dataset.formId) ||
        this.scope.querySelector('form[data-type="add-to-cart-form"]');
      this.lastVariantId = null;
      this.busy = false;

      this.onChange = this.onChange.bind(this);
      this.onQuantityInput = this.onQuantityInput.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSubmitCapture = this.onSubmitCapture.bind(this);

      this.addEventListener('change', this.onChange);

      var qty = this.quantityInput();
      if (qty) qty.addEventListener('change', this.onQuantityInput);

      // Le theme publie 'variant-change' (constants.js / pubsub.js) quand dispo.
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe('variant-change', this.onVariantChange);
      }
      // Filet de securite : un changement de variante sans pubsub.
      var picker = this.scope.querySelector('variant-selects, variant-radios');
      if (picker) {
        picker.addEventListener('change', function () {
          setTimeout(this.onVariantChange, 60);
        }.bind(this));
      }

      document.addEventListener('submit', this.onSubmitCapture, true);

      this.render();
      this.applySelection(this.selectedTier(), { silent: true });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('submit', this.onSubmitCapture, true);
    }

    quantityInput() {
      if (!this.form) return null;
      return this.form.querySelector('input[name="quantity"]') ||
        document.querySelector('input[name="quantity"][form="' + this.dataset.formId + '"]');
    }

    variantEntry(id) {
      var variants = this.data.variants || {};
      return id != null ? variants[String(id)] || null : null;
    }

    currentVariantId() {
      if (this.form) {
        var input = this.form.querySelector('input[name="id"], .product-variant-id');
        if (input && input.value && this.variantEntry(input.value)) return String(input.value);
      }
      if (this.lastVariantId) return this.lastVariantId;
      return String(this.data.defaultVariant);
    }

    /* Prix de la variante actuellement choisie dans le selecteur du theme, en centimes. */
    currentPrices() {
      var entry = this.variantEntry(this.currentVariantId());
      if (!entry) {
        var first = Object.keys(this.data.variants || {})[0];
        entry = first ? this.data.variants[first] : { price: 0, compare_at_price: 0 };
      }
      return entry;
    }

    pieceSelects(tier) {
      return tier ? Array.prototype.slice.call(tier.querySelectorAll('[data-ax-qb-piece]')) : [];
    }

    selectedTier() {
      return this.tiers.find(function (t) {
        var r = t.querySelector('input[type="radio"]');
        return r && r.checked;
      }) || this.tiers[0];
    }

    onChange(event) {
      var target = event.target;

      if (target.matches('[data-ax-qb-piece]')) {
        /* Choix explicite du client : ce selecteur ne suit plus le selecteur du theme. */
        target.dataset.touched = 'true';
        var owner = target.closest('[data-ax-qb-tier]');
        if (owner && !owner.classList.contains('is-selected')) {
          var radio = owner.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          this.applySelection(owner);
        }
        this.render();
        return;
      }

      if (target.matches('input[type="radio"]')) {
        var tier = target.closest('[data-ax-qb-tier]');
        if (tier) this.applySelection(tier);
      }
    }

    /* Variante changee dans le selecteur du theme : les pieces non modifiees suivent. */
    onVariantChange(event) {
      var fromEvent = event && event.data && event.data.variant && event.data.variant.id;
      var id = fromEvent ? String(event.data.variant.id) : this.currentVariantId();
      if (this.variantEntry(id)) this.lastVariantId = id;
      var self = this;
      this.tiers.forEach(function (tier) {
        self.pieceSelects(tier).forEach(function (select) {
          if (select.dataset.touched === 'true') return;
          var option = select.querySelector('option[value="' + id + '"]');
          if (option && !option.disabled) select.value = id;
        });
      });
      this.render();
    }

    /* Quantite modifiee a la main : on resynchronise le palier correspondant. */
    onQuantityInput() {
      var qty = this.quantityInput();
      if (!qty) return;
      var value = parseInt(qty.value, 10);
      var match = this.tiers.find(function (t) {
        return parseInt(t.dataset.qty, 10) === value;
      });
      this.tiers.forEach(function (t) {
        var r = t.querySelector('input[type="radio"]');
        var on = t === match;
        if (r) r.checked = on;
        t.classList.toggle('is-selected', on);
      });
      this.syncPicker(match || null);
      this.updateSummary(match || null);
    }

    applySelection(tier, options) {
      if (!tier) return;
      var opts = options || {};

      this.tiers.forEach(function (t) {
        t.classList.toggle('is-selected', t === tier);
      });

      var qty = this.quantityInput();
      var target = parseInt(tier.dataset.qty, 10) || 1;
      if (qty && parseInt(qty.value, 10) !== target) {
        qty.value = target;
        if (!opts.silent) {
          qty.dispatchEvent(new Event('input', { bubbles: true }));
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      this.syncPicker(tier);
      this.showError('');
      this.updateSummary(tier);
    }

    /*
      Palier multi-pieces : le selecteur de variante du theme ferait doublon (et ne
      piloterait qu'une seule piece), on le masque tant que ce palier est choisi.
    */
    syncPicker(tier) {
      var multi = this.pieceSelects(tier).length > 0;
      this.classList.toggle('has-pieces', multi);
      Array.prototype.forEach.call(
        this.scope.querySelectorAll('variant-selects, variant-radios, .shopify-payment-button'),
        function (el) { el.style.display = multi ? 'none' : ''; }
      );
    }

    updateSummary(tier) {
      if (this.summary) {
        var show = !!tier && parseInt(tier.dataset.discount, 10) > 0;
        this.summary.classList.toggle('is-visible', show);
        if (show) {
          var totalNode = this.summary.querySelector('[data-ax-qb-summary-total]');
          var saveNode = this.summary.querySelector('[data-ax-qb-summary-save]');
          if (totalNode) totalNode.textContent = this.summaryTotalLabel + ' ' + formatMoney(parseInt(tier.dataset.total, 10), this.moneyFormat);
          if (saveNode) saveNode.textContent = this.summarySaveLabel + ' ' + formatMoney(parseInt(tier.dataset.saving, 10), this.moneyFormat);
        }
      }

      if (!this.updateAtc || !tier) return;
      // Le theme rend deux boutons d'ajout (principal + barre collante), chacun avec
      // son propre formulaire : les deux doivent afficher le meme total.
      var total = parseInt(tier.dataset.total, 10) || 0;
      var saving = parseInt(tier.dataset.saving, 10) || 0;
      var fmt = this.moneyFormat;
      var label = ' – ' + formatMoney(total, fmt);
      Array.prototype.forEach.call(this.scope.querySelectorAll('.product-form__submit'), function (button) {
        var node = button.querySelector('.ax-qb-atc-total');

        /*
          buy-buttons.liquid rend un .price dans CHAQUE bouton : masqué sur le bouton
          principal, visible dans la barre collante. Là où il est visible, on met ce prix à
          jour au lieu d'ajouter un second montant (sinon « – 337.50 dh ✦ 125.00 dh »).
        */
        var priceBox = button.querySelector('.price');
        var ownPrice = priceBox && getComputedStyle(priceBox).display !== 'none'
          ? priceBox.querySelector('.price-item--last')
          : null;
        if (ownPrice) {
          ownPrice.textContent = formatMoney(total, fmt);
          var compare = priceBox.querySelector('.price-item--compare');
          if (compare) {
            if (compare.dataset.axOrig === undefined) compare.dataset.axOrig = compare.textContent;
            compare.textContent = saving > 0 ? formatMoney(total + saving, fmt) : compare.dataset.axOrig;
          }
          if (node) node.remove();
          return;
        }

        if (!node) {
          node = document.createElement('span');
          node.className = 'ax-qb-atc-total';
          var firstSpan = button.querySelector('span');
          if (firstSpan) firstSpan.insertAdjacentElement('afterend', node);
          else button.appendChild(node);
        }
        node.textContent = label;
      });
    }

    /* Recalcule tous les montants affiches (variante du theme, ou variante de chaque piece). */
    render() {
      var unit = parseInt(this.currentPrices().price, 10) || 0;
      var self = this;

      this.tiers.forEach(function (tier) {
        var qty = parseInt(tier.dataset.qty, 10) || 1;
        var pct = parseFloat(tier.dataset.discount) || 0;
        var selects = self.pieceSelects(tier);
        var before = selects.length
          ? selects.reduce(function (sum, select) {
              var entry = self.variantEntry(select.value);
              return sum + (entry ? parseInt(entry.price, 10) || 0 : unit);
            }, 0)
          : unit * qty;
        var total = Math.round(before * (1 - pct / 100));
        var perUnit = qty > 0 ? Math.round(total / qty) : total;

        tier.dataset.total = total;
        tier.dataset.saving = before - total;

        var totalNode = tier.querySelector('[data-ax-qb-total]');
        var wasNode = tier.querySelector('[data-ax-qb-was]');
        var unitNode = tier.querySelector('[data-ax-qb-unit]');
        var shipNode = tier.querySelector('[data-ax-qb-ship]');

        if (totalNode) totalNode.textContent = formatMoney(total, self.moneyFormat);
        if (wasNode) wasNode.textContent = pct > 0 ? formatMoney(before, self.moneyFormat) : '';
        if (unitNode) unitNode.textContent = formatMoney(perUnit, self.moneyFormat) + ' ' + self.perUnitSuffix;
        if (shipNode) {
          var qualifies = self.freeShipThreshold > 0 && total >= self.freeShipThreshold;
          shipNode.textContent = qualifies ? self.freeShipLabel : '';
        }
      });

      this.updateSummary(this.selectedTier());
    }

    showError(text) {
      if (!this.errorNode) return;
      this.errorNode.textContent = text || '';
      this.errorNode.hidden = !text;
    }

    /* Capture : s'execute avant l'ecouteur 'submit' de product-form.js. */
    onSubmitCapture(event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || !form.querySelector('[name="add"]')) return;
      /*
        Ne jamais lire form.id : le formulaire produit contient <input name="id">, qui
        « écrase » la propriété (form.id renvoie cet input, pas l'attribut).

        Et ne pas se fier à l'id de la barre collante : main-product.liquid passe
        `'sticky-' | append: product_form_id` en argument de {% render %}, qui ignore les
        filtres - son formulaire s'appelle donc « sticky- » tout court. On reconnaît les
        formulaires d'ajout (principal et barre collante) à leur présence dans la section.
      */
      var attrId = form.getAttribute('id') || '';
      var inSection = this.scope !== document && this.scope.contains(form);
      if (attrId !== this.dataset.formId && !inSection) return;

      var selects = this.pieceSelects(this.selectedTier());
      if (!selects.length) return; // palier simple : le theme gere l'ajout

      event.preventDefault();
      event.stopPropagation();
      this.addPieces(form, selects.map(function (s) { return s.value; }));
    }

    addPieces(form, ids) {
      if (this.busy) return;
      var self = this;

      var counts = {};
      var order = [];
      ids.forEach(function (id) {
        if (!counts[id]) { counts[id] = 0; order.push(id); }
        counts[id] += 1;
      });
      var items = order.map(function (id) { return { id: Number(id), quantity: counts[id] }; });

      var host = form.closest('product-form') || form.parentElement || form;
      var button = host.querySelector('[type="submit"]') || form.querySelector('[type="submit"]');
      var spinner = host.querySelector('.loading__spinner');

      this.busy = true;
      this.showError('');
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var drawer = document.querySelector('cart-drawer');
      var useDrawer = drawer && typeof drawer.getSectionsToRender === 'function' &&
        typeof drawer.renderContents === 'function';
      var body = { items: items };
      if (useDrawer) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.section; });
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, json: json }; });
        })
        .then(function (result) {
          if (!result.ok || result.json.status) {
            throw new Error(result.json.description || result.json.message || ADD_ERROR);
          }
          if (useDrawer && result.json.sections) {
            /* Comme product-form.js : sinon open() cherche l'etat vide et trapFocus plante. */
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(result.json);
            setTimeout(function () {
              if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open(button || undefined);
            }, 180);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          self.showError(err && err.message ? err.message : ADD_ERROR);
        })
        .finally(function () {
          self.busy = false;
          if (button) {
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    }
  }

  customElements.define('ax-quantity-breaks', AxQuantityBreaks);
})();
